import { RichiestaDTO, RichiestaModuloDTO } from '@framework/api-client';
import { SubmissionCardTabPanel } from '@framework/common-web';
import { EngineThemeProvider } from '@framework/engine';
import { FormCoordinator } from '@framework/form';
import {
  FlexSubmissionRow,
  ISubmissionMenuItem,
  ModuleFormSectionsMonitorContextProvider,
  SubmissionMenu,
  SubmissionPaymentsCard,
  useSubmissionNavigation,
} from '@framework/frontoffice-submission';
import { t } from '@framework/i18n';
import { Route } from '@framework/ui';
import React from 'react';
import { Switch } from 'react-router';
import { CompilationModuleCard } from '../../../components/submissions/cards/module/CompilationModuleCard';

export interface ISubmissionSentTabRequestProps {
  active?: boolean;
  submissionModuleId?: string | null;
  submission: RichiestaDTO | null | undefined;
  menuItems: ISubmissionMenuItem[];
  children?: React.ReactNode;
  initialModuleId?: string | null | undefined;
  submissionModules: RichiestaModuloDTO[];
}

/**
 * Tab delle comunicazioni post invio di una richiesta richiesta.
 */
export function SubmissionSentTabRequest(
  props: ISubmissionSentTabRequestProps,
) {
  const { active, submission, submissionModuleId, menuItems, initialModuleId } =
    props;

  const handleNavigation = useSubmissionNavigation({
    submissionId: submission?.id,
    steps: menuItems,
  });

  if (!active) return null;

  return (
    <SubmissionCardTabPanel
      active={active}
      label={t(
        'submission-sent-tab-sent-request.panel-aria',
        'Tab richiesta inviata',
      )}
    >
      <FormCoordinator>
        <ModuleFormSectionsMonitorContextProvider>
          <FlexSubmissionRow
            menuSide="right"
            menu={
              <SubmissionMenu
                items={menuItems}
                currentSubmissionModuleId={
                  submissionModuleId ?? initialModuleId ?? '<unknown>'
                }
              />
            }
          >
            <EngineThemeProvider>
              <Switch>
                <Route
                  exact
                  path="/richieste/:id/inviata"
                  render={(props: any) => (
                    <CompilationModuleCard
                      {...props}
                      initialModuleId={initialModuleId}
                      handleNavigation={handleNavigation}
                    />
                  )}
                />
                <Route
                  exact
                  path="/richieste/:id/inviata/moduli/:moduleId"
                  render={(props: any) => (
                    <CompilationModuleCard
                      {...props}
                      handleNavigation={handleNavigation}
                    />
                  )}
                />

                <Route
                  exact
                  path="/richieste/:id/inviata/pagamenti"
                  render={() => (
                    <SubmissionPaymentsCard
                      submissionId={submission?.id}
                      handleNavigation={handleNavigation}
                      submission={submission}
                    />
                  )}
                />
              </Switch>
            </EngineThemeProvider>
          </FlexSubmissionRow>
        </ModuleFormSectionsMonitorContextProvider>
      </FormCoordinator>
    </SubmissionCardTabPanel>
  );
}
